import AuthService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/AuthService";
import {AccessRoleType, AccessRoleTypeAll} from "../types/AccessRoleType";
import {Routes} from "../types/Routes";

export default class RoleUtils {
  /**
   * Dictionary to get the roles for every route.
   */
  public static roleAccessDictionary: { [key: string]: AccessRoleType[] } = {
    [Routes.PROFILE]: [
      AccessRoleType.ROLE_MANAGER,
      AccessRoleType.ROLE_CONTRACTOR,
      AccessRoleType.ROLE_ADMIN,
      AccessRoleType.ROLE_HR,
    ],
    [Routes.WORKLOG]: AccessRoleTypeAll,
    [Routes.TIME_OFF]: AccessRoleTypeAll,
    [Routes.RANKING]: AccessRoleTypeAll,
    [Routes.SITE]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.BADGES]: [AccessRoleType.ROLE_ADMIN],
    [Routes.TIME_OFF_REPORT]: [AccessRoleType.ROLE_ADMIN],
    [Routes.UNIFIED_REPORTS]: [AccessRoleType.ROLE_ADMIN],
    [Routes.VACATION_REPORT]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.CERTIFICATIONS]: AccessRoleTypeAll,
    [Routes.PROJECTS]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.PROJECTS_TIMELINE]: [AccessRoleType.ROLE_ADMIN],
    [Routes.POSITIONS]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.ASSIGNATIONS]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.CERTIFICATIONS_LIST]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.USERS]: [AccessRoleType.ROLE_ADMIN],
    [Routes.HOLIDAYS]: [AccessRoleType.ROLE_MANAGER, AccessRoleType.ROLE_ADMIN],
    [Routes.WORKLOG_REPORT]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.WORKLOGS_SUMMARY]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER],
    [Routes.ASSIGNATION_PROJECTION]: [AccessRoleType.ROLE_ADMIN],
    [Routes.OVER_STAFF_REPORT]: [AccessRoleType.ROLE_ADMIN],
    [Routes.KNOWLEDGE_BASE_LIST]: [
      AccessRoleType.ROLE_ADMIN,
      AccessRoleType.ROLE_MANAGER,
      AccessRoleType.ROLE_CONTRACTOR,
    ],
    [Routes.IMAGE_TEMPLATE_BUILDER]: [
      AccessRoleType.ROLE_ADMIN,
      AccessRoleType.ROLE_MANAGER,
      AccessRoleType.ROLE_HR,
    ],
    [Routes.DASHBOARD]: AccessRoleTypeAll,
    [Routes.FAQS]: AccessRoleTypeAll,
    [Routes.WORKLOG_MISSING_HOURS]: [AccessRoleType.ROLE_ADMIN],
    [Routes.TIME_OFF_MISSING_HOURS]: [AccessRoleType.ROLE_ADMIN],
    [Routes.ACCOMPLISHMENTS]: AccessRoleTypeAll,
    [Routes.PROPERTIES]: [AccessRoleType.ROLE_ADMIN],
    [Routes.ACCOMPLISHMENT_APPROVAL]: [AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER, AccessRoleType.ROLE_HR, AccessRoleType.ROLE_HIRING_MANAGER],
  };

  public static isAdmin = (): boolean => {
    return AuthService.hasAnyRole([AccessRoleType.ROLE_ADMIN]);
  };

  public static isManager = (): boolean => {
    return AuthService.hasAnyRole([AccessRoleType.ROLE_MANAGER]);
  };

  public static isAdminOrManager = (): boolean => {
    return AuthService.hasAnyRole([AccessRoleType.ROLE_ADMIN, AccessRoleType.ROLE_MANAGER]);
  };

  public static hasSomeRoleExceptHR = (): boolean => {
    return (
      AuthService.hasRole(AccessRoleType.ROLE_ADMIN) ||
      AuthService.hasRole(AccessRoleType.ROLE_MANAGER) ||
      AuthService.hasRole(AccessRoleType.ROLE_CONTRACTOR)
    );
  };

  public static hasOnlyContractorRole = (): boolean => {
    return AuthService.hasRole(AccessRoleType.ROLE_CONTRACTOR) && AuthService.getUser()?.roles.length === 1;
  };
}
